import { render, staticRenderFns } from "./ProjectAssessmentReport.vue?vue&type=template&id=135d9934&scoped=true"
import script from "./ProjectAssessmentReport.vue?vue&type=script&lang=js"
export * from "./ProjectAssessmentReport.vue?vue&type=script&lang=js"
import style0 from "./ProjectAssessmentReport.vue?vue&type=style&index=0&id=135d9934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d9934",
  null
  
)

export default component.exports